export const TOPICS = [
  {
    id: "profitability",
    name: "Profitability",
    tagline: "Are you actually making money?",
    icon: "TrendingUp",
    color: "#29ABE2",
    deep: "#005580",
    tint: "#E0F2FE",
  },
  {
    id: "cash_flow",
    name: "Cash Flow",
    tagline: "Is there enough in the bank?",
    icon: "Waves",
    color: "#0EA5E9",
    deep: "#075985",
    tint: "#E0F7FF",
  },
  {
    id: "profit_vs_cash",
    name: "Profit vs Cash Flow",
    tagline: "Busy but broke? Here's why",
    icon: "Scale",
    color: "#6366F1",
    deep: "#3730A3",
    tint: "#EEF2FF",
  },
  {
    id: "pricing_strategy",
    name: "Pricing Strategy",
    tagline: "What should you charge?",
    icon: "Tags",
    color: "#8B5CF6",
    deep: "#5B21B6",
    tint: "#F3E8FF",
  },
  {
    id: "mixed",
    name: "Mixed Challenge",
    tagline: "A bit of everything. Test yourself!",
    icon: "Sparkles",
    color: "#F59E0B",
    deep: "#B45309",
    tint: "#FEF3C7",
  },
];

export const TOPIC_MAP = TOPICS.reduce((a, t) => ({ ...a, [t.id]: t }), {});

export const LEVELS = [
  { id: "basic", name: "Basic", label: "Level 1", questions: 5 },
  { id: "intermediate", name: "Intermediate", label: "Level 2", questions: 5 },
  { id: "advanced", name: "Advanced", label: "Level 3", questions: 6 },
];

export const PASS_RATIO = 0.6; // 60% to clear a level
